<template>
  <div class="dealers-container">


      <DetailImages 
              :images="imagesData"
              :rows="2"
              :page-size="100"  
            />
            <DetailVideo
              :videos="videoPageData"
              :rows="1"
              :page-size="100"  
             
            />
      <div style="height: 80px;"></div>
  </div>
</template>

<script>
import { isPortraitFun, getUrlKey } from "@/utils/utils.js";
import { aiUrl } from "@/config/base";
import DetailImages from './detail-parts/images-m.vue';
import DetailVideo from './detail-parts/video-m.vue';
export default {
  name: 'Dealers',
  props: {
    question: {
      type: Object,
      default: ''
    },


    enhancedQuestion: {
      type: Object,
      default: ''
    },
    questionType: {
      type: Object,
      default: ''
    },
    // clientPosition: {
    //   type: Object,
    //   default: null
    // }
  },
     components: {
      DetailImages,
      DetailVideo
    },
  data() {
    return {
      dealers: [],
      isPortrait: isPortraitFun(),
      dealerUrl: '',
      testDriveUrl: '',
      token: '',
      currentQuestionKey: '',
      imagesData: [],// 图片数据
      videoPageData: [],// 视频数据
      imagesHasData: false, // 图片是否有数据
      videoHasData: false, // 视频是否有数据
    }
  },
  created() {
    const userInfo = localStorage.getItem('user');
    var token=''
    if(userInfo){
      this.userInfo = JSON.parse(userInfo)
      token = this.userInfo.token
    }
    this.token = token
    this.handleQuestionChangeImgView(this.question,this.enhancedQuestion,this.questionType);

 
  },
 
  methods: {


 handleQuestionChangeImgView(question,enhancedQuestion,questionType) {
          const { arrayString, firstItem } = this.normalizeQuestion(question);
          this.currentQuestionKey = firstItem || '';
          this.getImgs( firstItem, enhancedQuestion,questionType);
          this.getVideos(firstItem,enhancedQuestion,questionType);
        },
        // 获取图片数据
        async getImgs(providedFirst, enhancedQuestion,questionType) {
          const that = this;  
          this.$axios
            .post(
              `${aiUrl}keyword/searchImageByKeywords?pageNum=1&pageSize=500`,
              { 
                type: questionType,
                question: enhancedQuestion,
                model: providedFirst
              },
              {
                headers: {
                  token: that.token,
                },
              }
            )
            .then((res) => {
              const response = res.data || res;
              if (response.code == 200) {
                if (that.currentQuestionKey && providedFirst && that.currentQuestionKey !== String(providedFirst)) return; // 竞态保护
                that.imagesData = response.rows;
                //判断是否有没有数据
                if(that.imagesData && that.imagesData.length > 0){
                  that.imagesHasData = true;
                }else{
                  that.imagesHasData = false;
                }
              }
            })
        },
        // 获取视频数据
        async getVideos(providedFirst, enhancedQuestion, questionType) {
          const that = this;

          this.$axios
            .post(
              `${aiUrl}keyword/searchVideoByKeywords?pageNum=1&pageSize=500`,
              { 
                type: questionType,
                question: enhancedQuestion,
                model: providedFirst,
                pageNum: 1,
                pageSize: 100
              },
              {
                headers: {
                  token: that.token,
                },
              }
            )
            .then((res) => {
              const response = res.data || res;
              if (response.code == 200) {
                if (that.currentQuestionKey && providedFirst && that.currentQuestionKey !== String(providedFirst)) return; // 竞态保护
                that.videoPageData = response.rows;
                //判断是否有没有数据
                if(that.videoPageData && that.videoPageData.length > 0){
                  that.videoHasData = true;
                }else{
                  that.videoHasData = false;
                }
              }
            })
        },

         // 归一化question，返回标准的数组字符串和首个元素
        normalizeQuestion(question) {
          let processedQuestion = question;
          let firstItem = '';
          try {
            if (typeof question === 'string' && question.startsWith('[') && question.endsWith(']')) {
              const arr = JSON.parse(question);
              if (Array.isArray(arr) && arr.length > 0) {
                firstItem = String(arr[0] || '');
                processedQuestion = JSON.stringify([arr[0]]);
              }
            } else if (typeof question === 'string') {
              firstItem = question;
              processedQuestion = JSON.stringify([question]);
            } else if (Array.isArray(question)) {
              firstItem = String(question[0] || '');
              processedQuestion = JSON.stringify([question[0]]);
            } else if (question != null) {
              firstItem = String(question);
              processedQuestion = JSON.stringify([String(question)]);
            }
          } catch (_) {
            try {
              firstItem = String(question || '');
              processedQuestion = JSON.stringify([firstItem]);
            } catch (__) {
              processedQuestion = '[]';
              firstItem = '';
            }
          }
          return { arrayString: processedQuestion, firstItem };
        },

  
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 767px) {
  .dealers-container {
    width: 100%;
    height: 100%; /* 保持原有的高度计算 */
    overflow-y: auto; /* 关键修复：启用垂直滚动 */
    background-color: #fff;
 
    padding: 15px;
    box-sizing: border-box;
  }
  
  /* 可选：自定义滚动条样式 */
  .dealers-container::-webkit-scrollbar {
    width: 8px;
  }
  
  .dealers-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  .dealers-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  .dealers-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
}

 
</style>
